import React from "react";
import "../styles/LoadingSpinner.css";

export default function LoadingSpinner({
  show = true,
  fixed = false,
  text = "Loading...",
}) {
  if (!show) return null;

  return (
    <div className={`spinner-overlay ${fixed ? "fixed-overlay" : ""}`}>
      <div className="d-flex flex-column align-items-center justify-content-center gap-2">
        <div className="loading-spinner"></div>
        {text && (
          <span className="small fw-semibold text-primary tracking-wide">
            {text}
          </span>
        )}
      </div>
    </div>
  );
}
